import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IRegisterState {
  activeStep: number
}

const initialState: IRegisterState = {
  activeStep: 0,
}

export const slice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    onActiveStep: (
      state: IRegisterState,
      action: PayloadAction<typeof initialState.activeStep>
    ) => {
      state.activeStep = action.payload
    },
  },
})

export const { actions, reducer } = slice

export type IRegister = {
  register: IRegisterState
}
